module.exports = __webpack_public_path__ + "static/Calibre-Semibold-8325d174436d55e995c7214faafcd47b.ttf";